export const dateList = [
  {
    key: 1,
    value:'YYYY-mm-dd'
  },{
    key: 2,
    value:'yy-mm'
  },{
    key: 3,
    value:'mm-yy'
  },{
    key: 4,
    value:'mm-dd'
  },{
    key: 5,
    value:'dd-mm'
  },{
    key: 6,
    value:'dd-mm-YYYY'
  },{
    key: 7,
    value:'dd-mm-yy'
  },
]

export const timeList = [
  {
    key: 1,
    value:'HH:mm:ss'
  },{
    key: 2,
    value:'HH:mm'
  }
]

export const comBit = [
  {
    key: 1,
    value:'*'
  },{
    key: 2,
    value:'&'
  },{
    key: 3,
    value:'#'
  },{
    key: 4,
    value:'￥'
  },{
    key: 5,
    value:'无'
  }
]

export const dateBit = [
  {
    key: 1,
    value:'-'
  },{
    key: 2,
    value:'/'
  },{
    key: 3,
    value:','
  },{
    key: 4,
    value:'无'
  }
]

export const timeBit = [
  {
    key: 1,
    value:':'
  },{
    key: 2,
    value:'无'
  }
]

export const zeroList = [
  {
    key: 0,
    value:'否'
  },{
    key: 1,
    value:'是'
  }
]
export const updateList = [
  {
    key: 1,
    value:'每天'
  },{
    key: 2,
    value:'每周'
  },{
    key: 3,
    value:'每月'
  },{
    key: 4,
    value:'达到上限'
  }
]
export const contentTypeList = [
  {
    key: 1,
    value:'固定内容'
  },{
    key: 2,
    value:'关联字段'
  },{
    key: 3,
    value:'关联映射'
  }
]
